import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import AdminMenuWrapper from '@admin/nav_menu/AdminMenuWrapper';
import {
  FormModal,
  LongInput,
  ShortInput
} from '@components';
import styles from './QuoteHome.module.css';
import { showErrorMessage, showSuccessMessage } from '@global';
import {
  getQuotes,
  addQuote,
  editQuote
} from '@actions';

const CreateEditQuote = ({
  visible,
  quote,
  onCancel,
  isEdit,
  addQuote,
  editQuote
}) => {
  const [quoteInfo, setQuoteInfo] = useState(isEdit ? quote : { quote: "", author: ""});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setQuoteInfo(isEdit ? quote : { quote: "", author: ""});
  }, [quote, isEdit, visible]);

  const shouldBeEnabled = () => {
    return  quoteInfo.quote.length > 0 && quoteInfo.author.length > 0
  }

  const onSubmit = () => {
    setLoading(true);
    if (isEdit) {
      editQuote({
        ...quoteInfo,
        quote_id: quoteInfo.id
      }, () => {
        showSuccessMessage("Quote successfully updated!");
        onCancel();
        setLoading(false);
      }, () => {
        setLoading(false);
        showErrorMessage("Something went wrong");
      });
    } else {
      addQuote(quoteInfo, () => {
        showSuccessMessage("Quote successfully added!");
        onCancel();
        setLoading(false);
      }, () => {
        setLoading(false);
        showErrorMessage("Something went wrong");
      });
    }
  }

  return (
    <FormModal
      title={isEdit ? "Edit Quote" : "Add Quote"}
      visible={visible}
      onCancel={() => {
        onCancel();
      }}
      disabled={!shouldBeEnabled()}
      loading={loading}
      onSubmit={() => onSubmit()}
    >
      <div className={styles.modal_form_conainter}>
        <div style={{ fontSize: "12px", marginBottom: "12px", color: '#555' }}>
          Character count: {quoteInfo.quote.length}
        </div>
        <div className={styles.names_container}>
          <LongInput
            inputHeader="Quote"
            onChange={(val) => setQuoteInfo({ ...quoteInfo, quote: val })}
            value={quoteInfo.quote}
          />
        </div>

        <div className={styles.email_container}>
          <ShortInput
            inputHeader="Author"
            onChange={(val) => setQuoteInfo({ ...quoteInfo, author: val })}
            value={quoteInfo.author}
          />
        </div>
      </div>
    </FormModal>
  );
};

export default connect(null, {
  addQuote,
  editQuote
})(CreateEditQuote);
